// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__1tHHQ","react-select__control":"styles_react-select__control__1mvYm"};